enum ControlPanelActiveButtonEnum {
    reports = 1,
    campaigns = 2,
    reportDetails = 3
    
}

export default ControlPanelActiveButtonEnum